export default {
  HOME_HORIZONTAL_PADDING: 15,
  HOME_BUTTONS_SPACE: 8,
  // Mismo número de soporte que usa la app (NUMBER_CALL_CENTER).
  SUPPORT_WHATSAPP: '573212262010',
  // Lo más cerca que sigue mostrando las calles alrededor; inclinado se ven los edificios en 3D.
  // 30° deja ver los edificios sin que tapen tanto las vías (con 45° las cubrían).
  MAP_STREET_ZOOM: 18,
  MAP_BUILDINGS_TILT: 30,
};
